module.exports = __webpack_public_path__ + "media/images/logo/lewiatan-21a3254322b3793cd839862e0a5ea898.png";